/* eslint-disable react/no-danger */
import { useEffect, useState } from 'react';

import { ChevronDownOutline } from '@olist/design-system-icons';

import { FAQItemContainer } from './faq-item.styles';

interface IFaqItemProps {
  question: string;
  answer: string;
  index: string | number;
}

export function FaqItem({ answer, index, question }: IFaqItemProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const id = `questionAnswer-${index}`;

  const handleClick = () => {
    setIsOpen((currentState) => !currentState);
    const span = document.getElementById(id);
    if (span?.style.maxHeight === '0px' || !span?.style.maxHeight) {
      // @ts-ignore
      span.style.maxHeight = `${span?.scrollHeight}px`;
      // @ts-ignore
      span.style.marginTop = '18px';
      return;
    }

    span.style.maxHeight = '0';
    span.style.marginTop = '0';
  };

  useEffect(() => {
    if (document) {
      // @ts-ignore
      document.getElementById(id).innerHTML = answer;
    }
  }, [answer, id]);

  return (
    <FAQItemContainer isOpen={isOpen} className="faq-item">
      <button type="button" onClick={handleClick}>
        <div id={`button-text-${id}`} dangerouslySetInnerHTML={{ __html: question }} />
        <div className="chevron">
          <ChevronDownOutline />
        </div>
      </button>
      <span id={id} className="faq-answer" />
    </FAQItemContainer>
  );
}
